<table class="match-table">
    <thead *ngIf="match.showHeaders">
        <tr>
            <th class="match-header"></th>
            <th class="match-header"></th>
            <th *ngFor="let g of match.teams[0].games" class="match-header">
                <span class="match-game-header">{{ 'TOURNAMENTS.GAME' | translate }}&nbsp;{{ g.number }}</span>
            </th>
            <th *ngIf="match.type === 'DMK'" class='match-header' translate>TOURNAMENTS.SCORE</th>
            <th *ngIf="match.type !== 'DMK'" class='match-header'>
                <span *ngIf="round.name !== 'FINALS'" translate>TOURNAMENTS.MATCH</span>
                <span *ngIf="round.name === 'FINALS'" translate>TOURNAMENTS.FINISH</span>
            </th>
        </tr>
    </thead>
    <tbody *ngIf="!match.bye">
        <tr *ngFor="let t of match.teams; let i = index">
            <td *ngIf="i === 0" rowspan="2" class="match-pitch">{{ match.pitchName }}</td>
            <td class="match-team text-left">
                <div>{{ t.name }}<span *ngIf="match.type === 'BRACKET' && t.id > 0">&nbsp;({{ t.rank }})</span></div>
            </td>
            <td *ngFor="let game of t.games" class="match-game text-left">
                <span *ngIf="game.scoreMeaning === 'WON'" translate>SCORES.WON</span>
                <span *ngIf="game.scoreMeaning === 'LOST'" translate>SCORES.LOST</span>
                <span *ngIf="game.scoreMeaning === 'TIED'" translate>SCORES.TIED</span>
                <span *ngIf="game.scoreMeaning === 'TIED_LEADING'" translate>SCORES.TIEDLEADING</span>
                <span *ngIf="game.scoreMeaning === 'TIED_TRAILING'" translate>SCORES.TIEDTRAILING</span>
                <span *ngIf="game.scoreMeaning === 'NONE'">----</span>
            </td>
            <td *ngIf="match.type === 'DMK'" class="match-score text-left">{{ t.score | number: '1.1-2' }}</td>
            <td *ngIf="match.type !== 'DMK'" class="match-score text-left">
                <span *ngIf="round.name !== 'FINALS'">
                    <span *ngIf="match.teams[i].score > match.teams[(i === 0 ? 1 : 0)].score" translate>SCORES.WON</span>
                    <span *ngIf="match.teams[i].score < match.teams[(i === 0 ? 1 : 0)].score" translate>SCORES.LOST</span>
                </span>
                <span *ngIf="round.name === 'FINALS' && match.roundRank === 1">
                    <span *ngIf="match.teams[i].score > match.teams[(i === 0 ? 1 : 0)].score" translate>PLACEMENTS.FIRST</span>
                    <span *ngIf="match.teams[i].score < match.teams[(i === 0 ? 1 : 0)].score" translate>PLACEMENTS.SECOND</span>
                </span>
                <span *ngIf="round.name === 'FINALS' && match.roundRank === 2">
                    <span *ngIf="match.teams[i].score > match.teams[(i === 0 ? 1 : 0)].score" translate>PLACEMENTS.THIRD</span>
                    <span *ngIf="match.teams[i].score < match.teams[(i === 0 ? 1 : 0)].score" translate>PLACEMENTS.FOURTH</span>
                </span>
            </td>
        </tr>
    </tbody>
    <tbody *ngIf="match.bye">
        <tr>
            <td rowspan="2" class="match-pitch" translate>TOURNAMENTS.BYE</td>
            <td class="match-team text-left"><div>{{ match.teams[0].name }}</div></td>
            <td *ngFor="let game of match.teams[0].games" class="match-game text-left"></td>
            <td *ngIf="match.type === 'DMK'" class="match-score text-left">{{ match.teams[0].score | number: '1.1-2' }}</td>
            <td *ngIf="match.type !== 'DMK'"></td>
        </tr>
        <tr>
            <td class="match-team" style="color: var(--surface-b);">1</td>
            <td *ngFor="let game of match.teams[0].games"></td>
            <td></td>
        </tr>
    </tbody>
</table>
